require('./passwordService');

angular.module('app.shared.password.passwordController', [
  'app.shared.password.passwordService',
])
.controller('app.shared.password.passwordController', [
  '$scope',
  'app.shared.password.passwordService',
  function ($scope, passwordService) {
    "use strict";

    $scope.passwordChecker = passwordService.new();

    $scope.$watch(
      () => {
        return $scope.password;
      },
      () => {
        $scope.passwordPass = $scope.passwordChecker.validate($scope.password);
      }
    )
  }
]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/password/passwordController.js